import styled from "@emotion/styled";

import { fontCreteRound, fontMerriweather, fontRoboto } from "shared/lib/styles";

import {
  Figure as AvatarFigure,
  StyledImage as AvatarStyledImage,
} from "scmp-app/components/author/author-avatar/styles";
import { StyledAuthorAvatar } from "scmp-app/components/content/content-author-image/styles";
import {
  AuthorEntityLink,
  Authors,
  AuthorText,
} from "scmp-app/components/content/content-author/styles";
import { EntityLink } from "scmp-app/components/entity-link";

import LettersIconSvg from "./letters-icon.svg";

export const Container = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

export const ContentColumn = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: 8px;

  min-inline-size: 0;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AuthorName = styled.div`
  ${Authors}, ${AuthorText}, ${AuthorEntityLink} {
    color: #333333;
    font-weight: 400;
    font-size: 12px;
    font-family: ${fontMerriweather};
    line-height: normal;
  }
`;

export const StyledEntityLink = styled(EntityLink)`
  color: #000000;
`;

export const Kicker = styled.span`
  color: #2aa191;
`;

export const HeadlineLine = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 17px;
  font-family: ${fontCreteRound};
  line-height: 1.3;

  h1,
  h2 {
    display: inline;

    margin: 0;

    font: inherit;
  }
`;

export const Timestamp = styled.div`
  color: #727272;
  font-weight: 400;
  font-size: 11px;
  font-family: ${fontRoboto};
`;

export const Thumbnail = styled.div`
  flex-shrink: 0;

  min-inline-size: 60px;
  max-inline-size: 60px;
  min-block-size: 60px;
  max-block-size: 60px;

  ${StyledAuthorAvatar} {
    min-inline-size: 60px;
    max-inline-size: 60px;
    min-block-size: 60px;
    max-block-size: 60px;
  }

  ${AvatarFigure} {
    margin: 0;

    ${AvatarStyledImage} {
      filter: none;
    }
  }
`;

export const LettersIcon = styled(LettersIconSvg)`
  flex-shrink: 0;

  min-inline-size: 60px;
  max-inline-size: 60px;
  min-block-size: 60px;
  max-block-size: 60px;
`;
